import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { createFormGroupState, FormGroupState, setValue } from 'ngrx-forms';
import { EditTimeslotModel } from '@macs-frontend/features/company-management/agenda/service/types';
import { UUID, uuid4 } from '@macs-frontend/core/utils/uuid';
import { AssignmentTimeslotService } from '@macs-frontend/features/company-management/agenda/service/assignment-timeslot-service';
import { AppDateTime, parseAppDateTime } from '@macs-frontend/core/utils/datetime';
import { toAppDate } from '@macs-frontend/core/utils/date';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopupService } from '@macs-frontend/core/services/popup.service';

@Component({
  selector: 'md-assignment-confirm-dialog',
  templateUrl: './assignment-confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./assignment-confirm-dialog.component.scss'],
})
export class AssignmentConfirmDialogComponent implements OnInit {
  form$: FormGroupState<EditTimeslotModel> = createFormGroupState('editTimeslotForm', {
    uuid: uuid4(),
    date: undefined,
    startTime: undefined,
    endTime: undefined,
  });

  constructor(
    private readonly timeslotService: AssignmentTimeslotService,
    private readonly popupService: PopupService,
    public readonly dialogRef: MatDialogRef<AssignmentConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      uuid: UUID;
      date: AppDateTime;
      startTime: string;
      endTime: string;
    },
  ) {
    this.form$ = setValue<EditTimeslotModel>({
      ...this.form$.value,
      ...data,
    })(this.form$);
  }

  ngOnInit(): void {}

  public onStartTimeValueChange(event: Event) {
    this.form$.value.startTime = (event.target as HTMLInputElement).value;
  }

  public onDateValueChange(event: Event) {
    this.form$.value.date = (event.target as HTMLInputElement).value as AppDateTime;
  }

  public confirmTimeslot() {
    const date = toAppDate(parseAppDateTime(this.form$.value.date as AppDateTime));

    this.timeslotService
      .confirmTimeslot(this.form$.value.uuid, {
        confirm: true,
        date,
        startTime: this.form$.value.startTime,
      })
      .subscribe(_ => {
        this.popupService.alert('Confirmed').subscribe(__ => this.dialogRef.close(true));
      });
  }

  public rejectTimeslot() {
    this.timeslotService.rejectTimeslot(this.form$.value.uuid).subscribe(value => {
      this.popupService.alert('Rejected').subscribe(_ => this.dialogRef.close(false));
    });
  }
}
